import {
  ButtonBase,
  Collapse,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { classes } from "portal/theme/theme";
import { useLocalStorage } from "@uidotdev/usehooks";
import { useTranslation } from "react-i18next";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import React, { FC, PropsWithChildren } from "react";

interface FilterBarProps extends PropsWithChildren {
  collapsedSummary?: React.ReactNode;
  localStorageKey: string;
}

export const FilterBar: FC<FilterBarProps> = ({
  children,
  collapsedSummary,
  localStorageKey,
}) => {
  const { t } = useTranslation();
  const muiTheme = useTheme();
  const [expanded, setExpanded] = useLocalStorage(localStorageKey, true);

  const iconClasses = "text-xl w-[20px] h-[20px]";
  const iconStyles = { color: muiTheme.palette.text.primary };
  return (
    <Paper variant="section" className="rounded w-full">
      <ButtonBase
        className="flex justify-between items-center w-full gap-4 p-4"
        onClick={() => setExpanded(!expanded)}
        disableRipple
        disableTouchRipple
      >
        <Typography variant="caption" className="uppercase">
          {t("components.filters.filters")}
        </Typography>
        {!expanded && collapsedSummary ? (
          <div className="flex flex-wrap gap-1 mt-1 grow">
            {collapsedSummary}
          </div>
        ) : undefined}
        {expanded ? (
          <KeyboardArrowUpIcon
            className={classes(iconClasses)}
            style={iconStyles}
          />
        ) : (
          <KeyboardArrowDownIcon
            className={classes(iconClasses)}
            style={iconStyles}
          />
        )}
      </ButtonBase>
      <Collapse in={expanded}>
        <div className="pt-0 pb-4 px-4">{children}</div>
      </Collapse>
    </Paper>
  );
};
